import React from 'react';
import PropTypes from 'prop-types';
import InputConsumer from '../InputConsumer';
import { classes } from './WsrGroup.st.css';
const Group = ({ children }) => (React.createElement(InputConsumer, { consumerCompName: Group.displayName }, () => React.createElement("div", { className: classes.root }, children)));
Group.displayName = 'Input.Group';
Group.propTypes = {
    children: PropTypes.node,
};
export default Group;
//# sourceMappingURL=Group.js.map